import type { CardClose } from '@camino-solutions/share/proto/common/services';

export class SessionMessageProcessingCardCloseAction {
  static readonly type = '[Session] Message processing: Card close';

  constructor(readonly cardClose: CardClose) {}
}
